import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'Constants/env';
import { isNullOrUndefined } from 'Utils/typeGuards';
import API from '~/api';
import { useConversationStore } from '../index.store';
import { OptOutStatusResponse } from './index.types';

export const QUERY_KEY_FETCH_OPT_OUT_STATUS = 'conversation.fetchOptOutStatus';

export const fetchOptOutStatus = async (
  phoneNumbers: string[]
): Promise<Map<string, boolean>> => {
  if (phoneNumbers.length === 0) {
    return useConversationStore.getState().optOutPhoneNumbersInfo;
  }

  const { data: optOutStatusResponse } = await API.get<OptOutStatusResponse>(
    API_ENDPOINTS.OptOutStatus(),
    {
      params: { phoneNumbers },
    }
  );

  /**
   * The endpoint may return an empty array, or simply not include all the requested phone numbers.
   * In those cases, we will assume the number is not opted out.
   */
  phoneNumbers.forEach((phoneNumber) => {
    const optOutInfo = optOutStatusResponse.find(
      (contact) => contact.phoneNumber === phoneNumber
    );

    useConversationStore
      .getState()
      .updateOptOutPhoneNumberInfo(
        phoneNumber,
        isNullOrUndefined(optOutInfo) ? false : optOutInfo.optedOut
      );
  });

  return useConversationStore.getState().optOutPhoneNumbersInfo;
};

export const useFetchOptOutStatus = (phoneNumbers: string[]) =>
  useQuery({
    queryKey: [QUERY_KEY_FETCH_OPT_OUT_STATUS, phoneNumbers],
    queryFn: async () => fetchOptOutStatus(phoneNumbers),
  });
